import PropTypes from 'prop-types';
import DefaultTemplate from '../Default/DefaultTemplate';

const DownloadList = (props) => {
  return <DefaultTemplate {...props} showDownloadButton />;
};

DownloadList.propTypes = {
  items: PropTypes.arrayOf(PropTypes.any).isRequired,
  linkMore: PropTypes.any,
  isEditMode: PropTypes.bool,
};

export default DownloadList;
